import { render, staticRenderFns } from "./NewsImgZoom.vue?vue&type=template&id=20bae0d7&scoped=true&"
import script from "./NewsImgZoom.vue?vue&type=script&lang=js&"
export * from "./NewsImgZoom.vue?vue&type=script&lang=js&"
import style0 from "./NewsImgZoom.vue?vue&type=style&index=0&id=20bae0d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bae0d7",
  null
  
)

export default component.exports